import { PlOption } from 'pl-core-services';

export const PL_GRADE_OPTIONS: PlOption[] = [
  { value: 'Early Childhood', label: 'Early Childhood' },
  { value: 'Pre-K', label: 'Pre-K' },
  { value: 'K', label: 'Kindergarten' },
  { value: '1st', label: '1' },
  { value: '2nd', label: '2' },
  { value: '3rd', label: '3' },
  { value: '4th', label: '4' },
  { value: '5th', label: '5' },
  { value: '6th', label: '6' },
  { value: '7th', label: '7' },
  { value: '8th', label: '8' },
  { value: '9th', label: '9' },
  { value: '10th', label: '10' },
  { value: '11th', label: '11' },
  { value: '12th', label: '12' },
  { value: 'Adult', label: 'Adult' },
];
